<template>
  <div class="card organization-table">
    <!--  <header class="card-header has-background-dark">
      <p class="card-header-title has-text-light">ORGANIZATIONS</p>
    </header> -->
    <div class="card-content">
<!--       <base-table
        :service="firmService"
        fetch-func="getAll"
        :fetch-params="{ includes: 'managedBy', archived: archived }"
        :columns="$options.columns"
        default-sort-field="orderId"
        header-hidden
        sticky
        :height="height"
        infinite-scroll
        ref="baseTable"
      >
        <template #rowName="{ row }">
          <strike v-if="row.archived_at != null">{{ row.name }}</strike>
          <span v-else>{{ row.name }}</span>
        </template>

        <template #rowManagedBy="{ row, rowIndex, columnIndex }">
          
            <b-autocomplete
              :value="row.managedBy ? row.managedBy.name : ''"
              :data="filteredOrganizations"
              field="name"
              icon="search"
              @input="onManagedByInput"
              @blur="event => onManagedByBlur(row, rowIndex, columnIndex)"
              @select="option => updateManagedBy(row, option, rowIndex, columnIndex)"
              ref="autocompleteManagedBy"
            >
              <template slot="empty">No results found</template>
            </b-autocomplete>
          
        </template>

        <template #rowActions="{ row }">

          <span v-if="isSuperadmin">

            <button @click="archive(row, $event)" class="button is-small is-warning action-button" v-if="!row.archived_at">ARCHIVE</button>

            <button @click="restore(row, $event)" class="button is-small is-dark action-button" v-else>RESTORE</button>

            <button @click="onRemove(row, $event)" class="button is-small is-danger action-button">Delete</button>

          </span>

          <b-button :type="selected && selected.id === row.id ? 'is-info' : ''" class="action-button" size="is-small" @click="$emit('update:selected', row)">
            EDIT
          </b-button>

        </template>

      </base-table> -->

        <div style="padding:5px; border-bottom: 1px solid #c3c3c3;">

            <input type="text" class="input" placeholder="Search" v-model="keyword" ref="organizationSearch" style="max-width:300px;">
            
        </div>


        <table class="table is-striped is-hoverable" style="width:100%;">

            <tbody>

                <tr v-for="(organization, key) in filteredOrganizations" @click="$emit('update:selected', organization)" :class="selected && organization.id == selected.id ? 'active-firm' : ''">

                    <td>
                      <span v-if="organization.archived_at"><strike>{{ organization.name }}</strike></span>
                      <span v-else>{{ organization.name }}</span>
                    </td>
                
                </tr>
                
            </tbody>

        </table>

    </div>

  </div>

</template>

<script>

import BaseTable from "@/components/partials/BaseTable";

import { FirmService } from "@/services/firm.service";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  columns: [
    /* { field: "council_id", label: "ID" }, */
    {
      field: "name",
      label: "Name",
      searchable: true,
      meta: { rowSlot: "rowName" }
    },
    {
      field: "managedBy.name",
      label: "Managed By",
      searchable: true,
      meta: { rowSlot: "rowManagedBy" }
    },
    {
      field: "actions",
      label: "Actions",
      width: "80",
      meta: { rowSlot: "rowActions", class: "has-text-centered is-narrow action-td" }
    }
  ],
  props: {
    height: {
      type: Number,
      default: 500
    },
    selected: {
      type: Object,
      default: () => {}
    },

    archived: {
      type: Boolean,
      default: false
    },

    organizations: {},

  },
  components: {
    BaseTable
  },
  data: () => ({
    firmService: FirmService,
    // organizations: [],
    // filteredOrganizations: [],
    managers: {},
    keyword: '',
  }),
  computed: {
    userFirm() {
      return this.$store.state.Auth.user.firm;
    },

    isSuperadmin() {
        return this.$store.getters["Auth/hasRole"]("superadmin")
    },

    filteredOrganizations() {

        return this.organizations.filter(element => element.name.toLowerCase().includes(this.keyword.toLowerCase()));

    }

  },
  async mounted() {
    // await this.fetch();
    await this.getFirms();
    // this.selectUserFirm();
    this.$refs.organizationSearch.focus();
  },
  methods: {
    fetch() {
      return this.$refs.baseTable.fetchData().then(organizations => {
        this.organizations = organizations;
      });
    },
    selectUserFirm() {
      const selected = this.organizations.find(
        firm => firm.id === this.userFirm.id
      );
      this.$emit("update:selected", selected || null);
    },

    async archive(firm, event) {

      event.target.classList.toggle('is-loading');

      await FirmService.archive(firm.id).then(response => {

        event.target.classList.toggle('is-loading');

        // const firm = JsonDenormalizer.denormalize(response);

        this.$emit('reFetchOrganization');

      });

    },

    async restore(firm, event) {

      event.target.classList.toggle('is-loading');

      await FirmService.restore(firm.id).then(response => {

        event.target.classList.toggle('is-loading');

        // const firm = JsonDenormalizer.denormalize(response);

        this.$emit('reFetchOrganization');

      });

    },

    onRemove(firm, event) {
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to <b>delete</b> this organisation?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.remove(firm, event);
        }
      });
    },

    async remove(firm, event) {

      event.target.classList.toggle('is-loading');

      await FirmService.delete(firm.id).then(response => {

        this.$buefy.toast.open({
          message: "Organisation has been deleted.",
          type: "is-info",
          position: "is-top-right"
        });

        event.target.classList.toggle('is-loading');

        this.$emit('reFetchOrganization');

      });

    },

    async updateManagedBy(organization, managedBy, row, column) {
      if (!managedBy) return;

      try {
        const updatedOrganization = await this.firmService
          .updatePartial(organization.id, { managed_by: managedBy.id, includes: "managedBy" })
          .then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "Managed by has been updated.",
          type: "is-info",
          position: "is-top-right"
        });

        // Update organization's managedBy
        const index = this.organizations.findIndex(
          organization_ => organization_.id === organization.id
        );

        if (index) {
          this.organizations[index].managedBy = updatedOrganization.managedBy;
        }
      } catch (err) {
        setTimeout(() => {
          const managedByComponent = this.getManagedByComponent(row, column);
          managedByComponent.newValue = organization.managedBy
              ? organization.managedBy.name
              : "";
        }, 100);

        this.$buefy.toast.open({
          message: "Failed to update managed by.",
          type: "is-danger",
          position: "is-top-right"
        });
      }
    },
    getManagedByComponent(row, column) {
      const columnsLength = this.$options.columns.length;
      const managedByFieldIndex = (row * columnsLength) + column;
      
      return this.$refs.baseTable.$refs.btable.$children[managedByFieldIndex].$children[0];
    },
    onManagedByInput(value) {
      if (!value) return;

      this.filteredOrganizations = this.organizations.filter(
        organization =>
          organization.name
            .toString()
            .toLowerCase()
            .indexOf(value.toLowerCase()) >= 0
      );
    },
    onManagedByBlur(organization, row, column) {
      const managedByComponent = this.getManagedByComponent(row, column);
      
      setTimeout(() => {
        // Revert only to current managed by if value is not valid
        if (
          !this.organizations.find(organization_ =>
            organization_.name === managedByComponent.newValue
          )
        ) {
          managedByComponent.newValue = organization.managedBy
            ? organization.managedBy.name
            : "";
        }
      }, 100)
    },

    getFirms() {

        FirmService.getAll({ includes: 'managedBy', archived: this.archived }).then(response => {

            this.$emit('update:organizations', JsonDenormalizer.denormalize(response));

            // this.organizations = JsonDenormalizer.denormalize(response);

        });

    },

  }
};
</script>

<style lang="scss">
.organization-table {
  .card-content {
    padding: 0;
    
    .table td{
        padding:10px;
    }

  }

.action-button{

  min-width: 50px;

}

  .table .autocomplete .dropdown-menu {
    position: initial;
  }

  .table-wrapper{

  height: auto !important;

}
}


.active-firm {

    background-color:#008ee4 !important;
    color:white;
    font-weight:bold;

}


</style>



// WEBPACK FOOTER //
// src/components/pages/Users/list-new/partials/organizationTable.vue